import { createApp } from 'vue';
import { ConfigProvider, Layout, Menu, Button, Table, Form, Input, InputNumber, Select, Modal, Card, Statistic, Tabs, Tag, Space, Dropdown, Breadcrumb, List, Avatar, Descriptions, Divider, Popconfirm, Radio, DatePicker, Row, Col, Checkbox, Image, Upload } from 'ant-design-vue';
import App from './App.vue';
import router from './router';
import store from './store';

import 'ant-design-vue/dist/reset.css';
import './styles/global.css';

const app = createApp(App);

app.use(ConfigProvider);
app.use(Layout);
app.use(Menu);
app.use(Button);
app.use(Table);
app.use(Form);
app.use(Input);
app.use(InputNumber);
app.use(Select);
app.use(Modal);
app.use(Card);
app.use(Statistic);
app.use(Tabs);
app.use(Tag);
app.use(Space);
app.use(Dropdown);
app.use(Breadcrumb);
app.use(List);
app.use(Avatar);
app.use(Descriptions);
app.use(Divider);
app.use(Popconfirm);
app.use(Radio);
app.use(DatePicker);
app.use(Row);
app.use(Col);
app.use(Checkbox);
app.use(Image);
app.use(Upload);

app.use(router);
app.use(store);

app.mount('#app');
